import Icon from '../components/Icon.vue'

Icon.register({"battery-0":{"width":2304,"height":1792,"paths":[{"d":"M2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/battery-0.js
// module id = 346
// module chunks = 0